import { computed } from 'vue'
import type { SideBarList } from '../types/model/sidebar'
import { getAccessibleSidebarItems } from '@/modules/Core/utils/authorization'
import { useAuthStore } from '@/modules/Auth/store'

export default function useSideBar() {
  const authStore = useAuthStore()

  const sideBarList = computed<SideBarList>(() =>
    getAccessibleSidebarItems(authStore.role).map(
      ({ title, icon, value, link }) => ({
        title,
        icon,
        value,
        link,
      })
    )
  )

  return {
    sideBarList,
  }
}
